import { Link } from "react-router-dom";
import { Button, ButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { To } from "react-router-dom";
import React from "react";

const StyledButton = styled(Button)(() => ({
  fontSize: 9,
  border: "var(--primary-base)",
  background: "var(--primary-tint)",
  padding: "9px 32px",
  color: "var(--primary-base)!important",
  "&:hover": {
    background: "var(--primary-tint)",
    color: "var(--primary-base)!important",
  },
  "& .MuiButton-endIcon": {
    marginLeft: 3,
    "& .MuiSvgIcon-root": {
      fontSize: 10,
    },
  },
}));

const StyledLinkButton = StyledButton as React.ElementType;

export default function DownloadButton({
  to = {},
  text = "Download Template",
  ...rest
}: Omit<ButtonProps, "children"> & {
  to?: To;
  text?: React.ReactNode;
}) {
  return (
    <StyledLinkButton
      component={Link}
      to={to}
      size="small"
      disableElevation
      {...rest}
    >
      {text}
    </StyledLinkButton>
  );
}
